var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/Breadcrumbs/index.tsx
import React2, { useEffect, useRef, useState } from "react";
import { useTranslate } from "@volvo-cars/react-shared-translations";
import { Text as Text2, View as View2 } from "vcc-ui";

// src/Link/index.tsx
import React from "react";
import { useTracker } from "@volvo-cars/tracking";
import { Click, Icon, Text, View } from "vcc-ui";

// src/utils/getFontSize.ts
var getUnitlessFontSize = (variant) => {
  return variant.standard.styles.fontSize.replace("rem", "");
};

// src/Link/index.tsx
var Link = ({
  href,
  title,
  trackEventLabel,
  index,
  withBackArrow = false,
  trailLength = 0,
  isBreadcrumbCollapsed
}) => {
  const tracker = useTracker();
  const onClick = () => {
    tracker.interaction({
      eventAction: "click",
      eventLabel: trackEventLabel || `${index} | ${title}`
    });
  };
  const collapsable = index !== 0 && index !== trailLength - 1;
  return /* @__PURE__ */ React.createElement(View, {
    as: "li",
    direction: "row",
    extend: {
      visibility: isBreadcrumbCollapsed && collapsable && index !== trailLength - 2 ? "hidden" : "visible"
    }
  }, /* @__PURE__ */ React.createElement(Click, {
    href,
    onClick,
    extend: {
      display: "flex",
      color: "foreground.primary",
      ":focus": {
        color: "foreground.secondary",
        "& img": {
          content: `url(
              'https://www.volvocars.com/static/shared/icons/v1.1/navigation-arrowback-16.svg#light-secondary'
            )`
        }
      },
      extend: {
        condition: !withBackArrow,
        style: {
          color: "foreground.secondary",
          ":hover": {
            color: "foreground.action"
          }
        }
      }
    }
  }, withBackArrow && /* @__PURE__ */ React.createElement(View, {
    paddingRight: 1,
    justifyContent: "center",
    "aria-hidden": true
  }, /* @__PURE__ */ React.createElement(Icon, {
    type: "navigation-arrowback-16"
  })), /* @__PURE__ */ React.createElement(Text, {
    extend: {
      color: "inherit",
      extend: [
        {
          condition: index !== 0,
          style: {
            fromM: {
              maxWidth: "20ch",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap"
            }
          }
        },
        {
          condition: collapsable,
          style: {
            fromM: {
              fontSize: "var(--collapsable-font-size-c)!important"
            }
          }
        }
      ]
    }
  }, title), collapsable && index === trailLength - 2 ? /* @__PURE__ */ React.createElement(Text, {
    "aria-hidden": true,
    extend: ({
      theme: {
        typeScale: { columbus }
      }
    }) => ({
      color: "inherit",
      fontSize: `calc(var(--should-links-collapse-rem) * ${getUnitlessFontSize(columbus)})!important`
    })
  }, "...") : null), !withBackArrow && /* @__PURE__ */ React.createElement(Separator, {
    collapsable: collapsable && index !== trailLength - 2
  }));
};
var Separator = ({ collapsable }) => {
  return /* @__PURE__ */ React.createElement(View, {
    extend: ({ theme: { baselineGrid } }) => ({
      paddingLeft: baselineGrid,
      paddingRight: baselineGrid,
      fromM: {
        extend: {
          condition: collapsable,
          style: {
            paddingLeft: `var(--collapsable-padding)!important`,
            paddingRight: `var(--collapsable-padding)!important`
          }
        }
      }
    }),
    "aria-hidden": true,
    justifyContent: "center"
  }, /* @__PURE__ */ React.createElement(Text, {
    foreground: "foreground.secondary",
    extend: {
      userSelect: "none",
      fromM: {
        extend: {
          condition: collapsable,
          style: { fontSize: "var(--collapsable-font-size-c)!important" }
        }
      }
    }
  }, "/"));
};

// src/Breadcrumbs/index.tsx
var padding = (baselineGrid) => `${3 * baselineGrid}px 0px ${2 * baselineGrid}px ${2 * baselineGrid}px`;
var Breadcrumbs = ({
  trail,
  currentTitle,
  "aria-label": ariaLabel
}) => {
  const lastLink = trail[trail.length - 1];
  const [isBreadcrumbCollapsed, setIsBreadcrumbCollapsed] = useState(false);
  const ref = useRef(null);
  ariaLabel = useTranslate("react-breadcrumbs.ariaLabel", {
    disabled: !!ariaLabel
  }) || ariaLabel;
  const chars = trail.reduce((acc, link) => {
    return acc + link.title.length;
  }, 0) + currentTitle.length + trail.length;
  const totalPadding = (baselineGrid) => 2 * baselineGrid + 2 * baselineGrid * trail.length;
  useEffect(() => {
    if (!ref)
      return;
    const element = ref.current;
    if (!element)
      return;
    const resizeObserver = new ResizeObserver(() => {
      const value = window.getComputedStyle(element).getPropertyValue("font-size");
      setIsBreadcrumbCollapsed(value === "0px");
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.unobserve(element);
    };
  }, []);
  return /* @__PURE__ */ React2.createElement(View2, {
    ref,
    as: "nav",
    "aria-label": ariaLabel,
    extend: ({
      theme: {
        baselineGrid,
        typeScale: { columbus, bates }
      }
    }) => ({
      "--breadcrumb-width": `calc(${chars * 10}px + ${totalPadding(baselineGrid)}px)`,
      "--should-links-collapse-px": "clamp(0px, calc(var(--breadcrumb-width) - 90vw), 1px)",
      "--should-links-collapse-rem": "clamp(0rem, calc(calc(var(--should-links-collapse-px) * 10000) - 1000px), 1rem)",
      "--should-links-not-collapse-px": "calc(calc(var(--should-links-collapse-px) * -1) + 1px)",
      "--should-links-not-collapse-rem": "calc(calc(var(--should-links-collapse-rem) * -1) + 1rem)",
      "--collapsable-font-size-c": `calc(var(--should-links-not-collapse-rem) * ${getUnitlessFontSize(columbus)})`,
      fontSize: "var(--collapsable-font-size-c)",
      "--collapsable-padding": `calc(var(--should-links-not-collapse-px) * ${baselineGrid})`
    })
  }, /* @__PURE__ */ React2.createElement(View2, {
    as: "ol",
    direction: "row",
    extend: ({ theme: { baselineGrid } }) => ({
      untilM: { display: "none" },
      padding: padding(baselineGrid),
      margin: 0
    })
  }, trail.map((link, index) => /* @__PURE__ */ React2.createElement(Link, __spreadProps(__spreadValues({}, link), {
    key: index,
    isBreadcrumbCollapsed,
    index,
    trailLength: trail.length
  }))), /* @__PURE__ */ React2.createElement(CurrentTitle, {
    title: currentTitle
  })), /* @__PURE__ */ React2.createElement(View2, {
    as: "ol",
    extend: ({ theme: { baselineGrid } }) => ({
      fromM: { display: "none" },
      padding: padding(baselineGrid),
      margin: 0
    })
  }, /* @__PURE__ */ React2.createElement(Link, __spreadProps(__spreadValues({}, lastLink), {
    withBackArrow: true,
    index: trail.length - 1
  }))));
};
var CurrentTitle = ({ title }) => {
  return /* @__PURE__ */ React2.createElement(View2, {
    as: "li",
    "aria-current": "page"
  }, /* @__PURE__ */ React2.createElement(Text2, null, title));
};

// src/BreadcrumbsStructuredData/index.tsx
import React3, { useMemo } from "react";
var BreadcrumbsStructuredData = ({ trail, currentTitle, pretty }) => {
  const jsonLd = useMemo(() => JSON.stringify(generateBreadcrumbsStructuredData({ trail, currentTitle }), null, pretty ? 2 : void 0), [trail, currentTitle, pretty]);
  return /* @__PURE__ */ React3.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: { __html: jsonLd }
  });
};
function generateBreadcrumbsStructuredData({
  trail,
  currentTitle
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [...trail, { title: currentTitle, href: "" }].map(({ title, href }, index) => __spreadValues({
      "@type": "ListItem",
      position: index + 1,
      name: title
    }, href && { item: href }))
  };
}
export {
  Breadcrumbs,
  BreadcrumbsStructuredData,
  generateBreadcrumbsStructuredData
};
